import { render, staticRenderFns } from "./invoiceIng.vue?vue&type=template&id=5dcb46c0&scoped=true"
import script from "./invoiceIng.vue?vue&type=script&lang=ts"
export * from "./invoiceIng.vue?vue&type=script&lang=ts"
import style0 from "./invoiceIng.vue?vue&type=style&index=0&id=5dcb46c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcb46c0",
  null
  
)

export default component.exports